/**
 * a11y dialog
 */

 var component_a11y_dialog = function() {

  var dialogEl = document.getElementById('my-dialog')

  if(dialogEl) {
    var dialog = new A11yDialog(dialogEl)

    dialog.on('show', function (dialogEl, triggerEl) {
      console.log(dialogEl)
      console.log(triggerEl)
    })
  }


};
